import { React, useState } from "react";
import { NavLink, useNavigate } from "react-router-dom";
import logo from "../../assets/images/newLogo.png";
import {
  HomeIcon,
  ApplicationIcon,
  CasesIcon,
  PatientSearchIcon,
  ClaimsIcon,
  CreateAppIcon,
  ProfileIcon,
  LogoutIcon,
} from "../../assets/index";
import { useDispatch, useSelector } from "react-redux";
import { resetLogin } from "../../stores/slices/loginSlice";
import { language } from "../../stores/slices/languageSlice";
import { resetApplicationsLists, resetApplicationUpdateflage } from "../../stores/slices/applicationsSlice";
import { resetLookup } from "../../stores/slices/lookupSlice";
import { resetPortalMessages } from "../../stores/slices/portalMessagesSlice";
import { resetPreAuth } from "../../stores/slices/preAuthSlice";
import { resetRecentActivities } from "../../stores/slices/recentActivitiesSlice";
import { resetRequiredActions, setViewAllFlage } from "../../stores/slices/requiredActionsSlice";
import { resetAppViewDetails } from "../../stores/slices/appViewDetailsSlice";
import { setConditionalRoute } from "../../stores/slices/generalConfiguration/routeRestrictionSlice";
import { Modal } from "antd";
import {
  Home,
  Inbox,
  FileText,
  HardDrive,
  CreditCard,
  Trello,
  Database,
  Menu,
  Search,
} from "react-feather";
import { CASE_MANAGEMENT_URL } from '../../constant/Constants';

function SideMenu() {
  const navigate = useNavigate();
  const dispatch = useDispatch();

  const selectedLanguage = useSelector(language).Sidemenu;
  const routeRestrict = useSelector((state) => state.routeRestrictionSlice);

  // restricted route modal & route path
  const [routeRestrictionModal, setRouteRestrictionModal] = useState(false);
  const [popupOpen, setPopupOpen] = useState(false);
  const [routePath, setRoutePath] = useState("");

  const onClickConditionalRoute = (action) => {
    setRouteRestrictionModal(true);
    dispatch(setViewAllFlage(false))
    setRoutePath(action);
  };

  return (
    <div>
      <Modal
        title=""
        open={routeRestrictionModal}
        onCancel={() => {
          setRouteRestrictionModal(false);
        }}
        onOk={() => {
          navigate(`/${routePath}`)
          dispatch(setConditionalRoute({
            isFlag: false,
            currentFlow: '',
          }));
          setRouteRestrictionModal(false);
          dispatch(setViewAllFlage(false))
        }}
        okText={'Move Away'}
        cancelText={'Stay Here'}
        maskClosable={false}
        closable={false}
      >
        <span className='modal_style'>  Moving away from this screen will discard your {routeRestrict.conditionalRouteFlow} information entered so far.</span>
      </Modal>
      <nav className="side-nav">
        <div className="intro-x d-flex align-items-right ps-5 pt-4 imgPadding">
          <div className="logo-img-wrap">
          <img alt="logo" className="w-25-nope" src={logo} />
          </div>
        </div>
        <div className="side-nav__devider my-6"></div>
        <ul style={{ padding: 0 }}>
          <li>
            {!routeRestrict.conditionalRoute ? (
              <NavLink
                className={({ isActive, isPending }) =>
                  isPending
                    ? "side-menu"
                    : isActive
                      ? "side-menu side-menu--active side-menu--open"
                      : "side-menu"
                }
                to="/dashboard"
              >
                <div className="side-menu__icon yellow">
                  <Menu />
                </div>
                <div className="side-menu__title nav-p">
                  Dashboard
                </div>
              </NavLink>
            ) : (
              <a
                className={"side-menu"}
                onClick={() => onClickConditionalRoute("dashboard")}
              >
                <div className="side-menu__icon yellow">
                  <Menu />
                </div>
                <div className="side-menu__title nav-p">
                  Dashboard
                </div>
              </a>
            )}
          </li>
          <li>
            {!routeRestrict.conditionalRoute ? (
              <NavLink
                className={({ isActive, isPending }) =>
                  isPending
                    ? "side-menu"
                    : isActive
                      ? "side-menu side-menu--active side-menu--open"
                      : "side-menu"
                }
                to="/createApp"
                onClick={() => {
                  dispatch(setViewAllFlage(false))
                }}
              >
                <div className="side-menu__icon yellow">
                  <Home />
                </div>
                <div className="side-menu__title nav-p">
                  {selectedLanguage.applyfor}
                </div>
              </NavLink>
            ) : (
              <a
                className={"side-menu side-menu--active side-menu--open"}
                onClick={() => onClickConditionalRoute("createApp")}
              >
                <div className="side-menu__icon yellow">
                  <Home />
                </div>
                <div className="side-menu__title nav-p">
                  {selectedLanguage.applyfor}
                </div>
              </a>
            )}
          </li>
          <li>
            {!routeRestrict.conditionalRoute ? (
              <NavLink
                className={({ isActive, isPending }) =>
                  isPending
                    ? "side-menu"
                    : isActive
                      ? "side-menu side-menu--active side-menu--open"
                      : "side-menu"
                }
                to="/searchPatient"
              >
                <div className="side-menu__icon yellow">
                  <Search />
                </div>
                <div className="side-menu__title nav-p">
                  Patient Search
                </div>
              </NavLink>
            ) : (
              <a
                className={"side-menu"}
                onClick={() => onClickConditionalRoute("searchPatient")}
              >
                <div className="side-menu__icon yellow">
                  <Search />
                </div>
                <div className="side-menu__title nav-p">
                  Patient Search
                </div>
              </a>
            )}
          </li>
          <li>
            {!routeRestrict.conditionalRoute ? (
              <NavLink
                className={({ isActive, isPending }) =>
                  isPending
                    ? "side-menu"
                    : isActive
                      ? "side-menu side-menu--active side-menu--open"
                      : "side-menu"
                }
                to="/applications"
              >
                <div className="side-menu__icon yellow">
                  <Inbox />
                </div>
                <div className="side-menu__title nav-p">
                  {selectedLanguage.applications}
                </div>
              </NavLink>
            ) : (
              <a
                className={"side-menu"}
                onClick={() => onClickConditionalRoute("applications")}
              >
                <div className="side-menu__icon yellow">
                  <Inbox />
                </div>
                <div className="side-menu__title nav-p">
                  {selectedLanguage.applications}
                </div>
              </a>
            )}
          </li>
          <li>
            {!routeRestrict.conditionalRoute ? (
              <NavLink
                className={({ isActive, isPending }) =>
                  isPending
                    ? "side-menu"
                    : isActive
                      ? "side-menu side-menu--active side-menu--open"
                      : "side-menu"
                }
                to="/claims"
              >
                <div className="side-menu__icon yellow">
                  <FileText />
                </div>
                <div className="side-menu__title nav-p">
                  {selectedLanguage.claims}
                </div>
              </NavLink>
            ) : (
              <a
                className={"side-menu"}
                onClick={() => onClickConditionalRoute("claims")}
              >
                <div className="side-menu__icon yellow">
                  <FileText />
                </div>
                <div className="side-menu__title nav-p">
                  {selectedLanguage.claims}
                </div>
              </a>
            )}
          </li>
          {/* <li>
            {!routeRestrict.conditionalRoute ? (
              <NavLink
                className={({ isActive, isPending }) =>
                  isPending
                    ? "side-menu"
                    : isActive
                      ? "side-menu"
                      : "side-menu"
                }
                // to={CASE_MANAGEMENT_URL}
                // target="_blank"
                onClick={() => {
                  setPopupOpen(true)}
                }
              >
                <div className="side-menu__icon yellow">
                  <HardDrive />
                </div>
                <div className="side-menu__title nav-p">
                  {selectedLanguage.cases}
                </div>
              </NavLink>
            ) : (
              <a
                className={"side-menu"}
                onClick={() => {onClickConditionalRoute("cases")
                  setPopupOpen(true)}
                }
              >
                <div className="side-menu__icon yellow">
                  <HardDrive />
                </div>
                <div className="side-menu__title nav-p">
                  {selectedLanguage.cases}
                </div>
              </a>
            )}
          </li> */}
          <li className="side-nav__devider my-6"></li>
          <li>
            {!routeRestrict.conditionalRoute ? (
              <NavLink
                className={({ isActive, isPending }) =>
                  isPending
                    ? "side-menu"
                    : isActive
                      ? "side-menu side-menu--active side-menu--open"
                      : "side-menu"
                }
                to="/educationResourceLibrary"
              >
                <div className="side-menu__icon yellow">
                  <CreditCard />
                </div>
                <div className="side-menu__title nav-p">
                  {selectedLanguage.educationResource}
                </div>
              </NavLink>
            ) : (
              <a
                className={"side-menu"}
                onClick={() => onClickConditionalRoute("patientSearch")}
              >
                <div className="side-menu__icon yellow">
                  <CreditCard />
                </div>
                <div className="side-menu__title nav-p">
                  {selectedLanguage.educationResource}
                </div>
              </a>
            )}
          </li>
          <li>
            {!routeRestrict.conditionalRoute ? (
              <NavLink
                className={({ isActive, isPending }) =>
                  isPending
                    ? "side-menu"
                    : isActive
                      ? "side-menu side-menu--active side-menu--open"
                      : "side-menu"
                }
                to="/financialResourceDirectory"
              >
                <div className="side-menu__icon yellow">
                  <Trello />
                </div>
                <div className="side-menu__title nav-p">
                  {selectedLanguage.financialResource}
                </div>
              </NavLink>
            ) : (
              <a
                className={"side-menu"}
                onClick={() => onClickConditionalRoute("financialResourceDirectory")}
              >
                <div className="side-menu__icon yellow">
                  <Trello />
                </div>
                <div className="side-menu__title nav-p">
                  {selectedLanguage.financialResource}
                </div>
              </a>
            )}
          </li>

          <li>
            {!routeRestrict.conditionalRoute ? (
              <NavLink
                className={({ isActive, isPending }) =>
                  isPending
                    ? "side-menu"
                    : isActive
                      ? "side-menu side-menu--active side-menu--open"
                      : "side-menu"
                }
                to="/reports"
              >
                <div className="side-menu__icon yellow">
                  <Database />
                </div>
                <div className="side-menu__title nav-p">
                  {selectedLanguage.reports}
                </div>
              </NavLink>
            ) : (
              <a
                className={"side-menu"}
                onClick={() => onClickConditionalRoute("reports")}
              >
                <div className="side-menu__icon yellow">
                  <Database />
                </div>
                <div className="side-menu__title nav-p">
                  {selectedLanguage.reports}
                </div>
              </a>
            )}
          </li>
        </ul>
      </nav>
      <Modal
        title=""
        open={popupOpen}
        onOk={(e) => {
          window.open("https://pafcm--uat.sandbox.my.site.com/cm/s/intake?language=en_US", "_blank");
        }}
        onCancel={() => {
          setPopupOpen(false)
        }}
        width={800}
        maskClosable={false}
        closeIcon={true}
        okText="Submit"
        cancelText="Close"
        >
        <p className="modal_style">
        You are now leaving the Non-Profit Patient Partner Portal to access the online case management referral form.  If you have more actions to take in the portal, please log back in after making your case management referral.
        </p>
      </Modal>
    </div>
  );
}

export default SideMenu;
